import gql from "graphql-tag"

export const setGdprPreferencesMutation = gql`
  mutation setGdprPreferences(
    $email: String!
    $source: String!
    $service: Boolean!
    $marketing: Boolean!
    $profiling: Boolean!
    $third_parties: Boolean!
    $terms_and_conditions: Boolean!
  ) {
    setGdpr(
      email: $email
      source: $source
      service: $service
      marketing: $marketing
      profiling: $profiling
      third_parties: $third_parties
      terms_and_conditions: $terms_and_conditions
    ) {
      service
      email
      source
      marketing
      profiling
      third_parties
      terms_and_conditions
      date
    }
  }
`
